/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
     {/* <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      /> */}



      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div> */}
      <AsideMenuItemWithSub
        to='/crafted/pages'
        title='Jobs Mgmt'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/briefcase.svg'
      >
         <AsideMenuItem to='/joblist' title='Jobs Directory' hasBullet={true} />
          <AsideMenuItem to='/pendingcareer' title='Pending Jobs' hasBullet={true} />
          <AsideMenuItem to='/expiredcareer' title='Expired Jobs' hasBullet={true} />
          <AsideMenuItem to='/createjob' title='Post a Job' hasBullet={true} />
          <AsideMenuItem to='/jobapplications' title='Job Applications' hasBullet={true} />
          <AsideMenuItem to='/wagedata' title='Wage Data' hasBullet={true} />
          {/* <AsideMenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} /> */}


        {/* <AsideMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <AsideMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <AsideMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </AsideMenuItemWithSub> */}
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/crafted/accounts'
        title='Companies Mgmt'
        icon='/media/icons/duotune/communication/company.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/companydirectory' title='Company Directory' hasBullet={true} />
        <AsideMenuItem to='/pendingcompany' title='Pending Companies' hasBullet={true} />
        <AsideMenuItem to='/createcompany' title='Add Company' hasBullet={true} />
        {/*<AsideMenuItem to='/perkslist' title='Perks List' hasBullet={true} />
        <AsideMenuItem to='/companyjobapplications' title='Company Job Applications' hasBullet={true} />
      <AsideMenuItem to='/companyVideoUpload' title='Upload Company Video' hasBullet={true} />
         <AsideMenuItem to='/mergecompany' title='Merge Companies' hasBullet={true} /> */}
         <AsideMenuItem to='/mergewithcompany' title='Merge Companies' hasBullet={true} />
         <AsideMenuItem to='/managehomepagevideos' title='Manage Homepage Videos' hasBullet={true} />
      </AsideMenuItemWithSub>




      {/* <AsideMenuItemWithSub
        to='/crafted/accounts'
        title='Careers Administration'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/crafted/account/overview' title='Careers Directory' hasBullet={true} />
        <AsideMenuItem to='/crafted/account/settings' title='Pending Careers' hasBullet={true} />
        <AsideMenuItem to='/crafted/account/settings' title='Expired Careers' hasBullet={true} />

      </AsideMenuItemWithSub>  */}


      <AsideMenuItemWithSub
        to='/crafted/accounts'
        title='Profiles Mgmt'
        icon='/media/icons/duotune/communication/user-profile.svg'
        fontIcon='bi-person'
      >
        {/* <AsideMenuItem to='/createprofile' title='Create Profile' hasBullet={true} /> */}
        <AsideMenuItem to='/createjobseeker' title='Create Profile' hasBullet={true} />
        <AsideMenuItem to='/profiledirectory' title='Published Profiles' hasBullet={true} />
        <AsideMenuItem to='/pendingprofile' title='Pending Profiles' hasBullet={true} />
        <AsideMenuItem to='/expiredprofile' title='Expired Profiles' hasBullet={true} />

      </AsideMenuItemWithSub>




      {/* <AsideMenuItemWithSub
        to='/'
        title='Profiles'
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/gen040.svg'
      >
        <AsideMenuItem to='/' title='Profile Directory' hasBullet={true} />
        <AsideMenuItem to='/' title='Pending Profiles' hasBullet={true} />
        <AsideMenuItem to='/' title='Expired Profiles' hasBullet={true} />
      </AsideMenuItemWithSub> */}
      <AsideMenuItemWithSub
        to='/crafted/widgets'
        title='Students Mgmt'
        icon='/media/icons/duotune/general/student.svg'
        fontIcon='bi-layers'
      >
        {/* <AsideMenuItem to='/explorequest' title='View Exploration Request' hasBullet={true} /> */}
        {/* <AsideMenuItem to='/studentregistartion' title='Student Registration' hasBullet={true} /> */}
        <AsideMenuItem to='/schoollist' title='Site Schools' hasBullet={true} />
        <AsideMenuItem to='/createschool' title='Add School' hasBullet={true} />
        <AsideMenuItem to='/studentlist' title='Student List' hasBullet={true} />
        <AsideMenuItem to='/createstudent' title='Add Student' hasBullet={true} />
        {/* <AsideMenuItem to='/convertstresume' title='Convert Students Resumes' hasBullet={true} /> */}

      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/'
        title='Reports'
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/reports.svg'
      >
        <AsideMenuItem to='/jobsreport' title='Jobs Report' hasBullet={true} />

        <AsideMenuItem to='/companyreport' title='Companies Report' hasBullet={true} />

        <AsideMenuItem to='/profilereport' title='Job Seekers Report' hasBullet={true} />

        <AsideMenuItem to='/studentreport' title='Students Report' hasBullet={true} />
       
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/crafted/widgets'
        title='Site Mgmt'
        icon='/media/icons/duotune/general/site.svg'
        fontIcon='bi-layers'
      >
        {/* <AsideMenuItem to='/crafted/widgets/lists' title='Pages' hasBullet={true} /> */}
          <AsideMenuItem to='/eventlist' title='Events' hasBullet={true} />
         <AsideMenuItem to='/createevent' title='Add Event' hasBullet={true} />

        <AsideMenuItem to='/notificationlist' title='Notifications' hasBullet={true} />
        <AsideMenuItem to='/addnotification' title='Add Notification' hasBullet={true} />

        {/* <AsideMenuItem to='/crafted/widgets/charts' title='Widgets' hasBullet={true} /> */}
        <AsideMenuItem to='/userlist' title='Users' hasBullet={true} />
        <AsideMenuItem to='/createuser' title='Add User' hasBullet={true} />

      </AsideMenuItemWithSub>

      
      
      <AsideMenuItemWithSub
        to='/'
        title='Config'
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/config.svg'
      >
        <AsideMenuItem to='/industrylist' title='Industry List' hasBullet={true} />
        <AsideMenuItem to='/createindustry' title='Add Industry' hasBullet={true} />

        <AsideMenuItem to='/educationlist' title='Education List' hasBullet={true} />
        <AsideMenuItem to='/createeducation' title='Add Education' hasBullet={true} />

        <AsideMenuItem to='/joblocationcountrylist' title='Job Location List' hasBullet={true} />
        <AsideMenuItem to='/createjoblocation' title='Add Job Location' hasBullet={true} />

        <AsideMenuItem to='/jobtypelist' title='Job Type List' hasBullet={true} />
        <AsideMenuItem to='/createjobtype' title='Add Job Type' hasBullet={true} />

      </AsideMenuItemWithSub>





    </>
  )
}
